import clsx from 'clsx';
import React, { forwardRef } from 'react';
import { SIZE, VARIANT } from '@blackcart/base';
import styles from './Button.module.css';

export type ButtonProps = {
  outlined?: boolean;
  full?: boolean;
  size?: 'small' | 'large';
  variant?: 'round' | 'square' | 'regular';
  text?: string;
  colors?: { background?: string; text?: string };
} & Omit<React.ButtonHTMLAttributes<HTMLButtonElement>, 'children'>;

const Button: React.ForwardRefExoticComponent<
  React.PropsWithoutRef<ButtonProps> & React.RefAttributes<HTMLButtonElement>
> = forwardRef<HTMLButtonElement, ButtonProps>((props, ref) => {
  const {
    outlined = false,
    full = false,
    variant = VARIANT.REGULAR,
    size = SIZE.LARGE,
    colors,
    id,
    className,
    text,
    style,
    ...rest
  } = props;
  return (
    <button
      id={id}
      style={{
        ...(style || {}),
        '--bcButton-textColor': colors?.text,
        '--bcButton-bgColor': colors?.background
      }}
      className={clsx(
        styles.root,
        {
          [styles.round]: variant === VARIANT.ROUND,
          [styles.square]: variant === VARIANT.SQUARE,
          [styles.regular]: variant === VARIANT.REGULAR,
          [styles.small]: size === SIZE.SMALL,
          [styles.large]: size === SIZE.LARGE,
          [styles.solid]: !outlined,
          [styles.outlined]: outlined,
          [styles.full]: full
        },
        'bc-button',
        className
      )}
      ref={ref}
      {...rest}
    >
      {text}
    </button>
  );
});

export { Button };
